export default __webpack_public_path__ + "static/media/10minbbq.3f5d3eb8.svg";